import {LEAD_EVENT, PHONE_VIEWED} from '../../../../../config.js'
import events from '../../../../../events.js'

const {RESERVATION_START_CLICKED, RESERVATION_MORE_INFORMATION_CLICKED} = events

export const PROFESSIONAL_SELLER_TYPE = 'profesional'

export const TOTAL_PROFESSIONAL_LEAD_TRIGGERED_DETAIL = 'Total Leads Detalle Profesionales'

export const EVENTS_NAME = {
  LEAD_TRIGGERED_EMAIL_DETAIL: {
    EVENT: LEAD_EVENT,
    EVENT_OPTIMIZELY: 'Lead Triggered Email Detail',
    EVENT_OPTIMIZELY_PROFESSIONAL: 'Lead Detalle Profesionales Mensaje',
    LEAD_TYPE: 'Detail Ad Replied Email',
    PAGE_NAME_ORIGIN: 'detail'
  },
  LEAD_TRIGGERED_DETAIL_PRI_AND_PRO: {
    EVENT: LEAD_EVENT,
    EVENT_OPTIMIZELY: 'Lead Triggered Detail Pri And Pro Web',
    LEAD_TYPES: [
      'Detail Ad Replied Email',
      'Detail Phone Called',
      'Detail Ad Replied Whatsapp',
      'Financed Purchase Phone Called',
      'Financed Purchase Email'
    ],
    PAGE_NAME_ORIGIN: 'detail'
  },
  LEAD_TRIGGERED_DETAIL_RESERVATION: {
    EVENT: LEAD_EVENT,
    EVENT_OPTIMIZELY: 'Lead Triggered Detail Reservation Web',
    LEAD_TYPES: [
      'Detail Ad Replied Email',
      'Detail Phone Called',
      'Detail Ad Replied Whatsapp',
      'Financed Purchase Phone Called',
      'Financed Purchase Email'
    ],
    PAGE_NAME_ORIGIN: 'detail'
  },
  LEAD_TRIGGERED_PHONE_DETAIL: {
    EVENT: LEAD_EVENT,
    EVENT_OPTIMIZELY_PROFESSIONAL: 'Lead Detalle Profesionales Llamada',
    LEAD_TYPE: 'Detail Phone Called'
  },
  LEAD_TRIGGERED_CALL_ME_BACK_DETAIL: {
    EVENT: LEAD_EVENT,
    LEAD_TYPE: 'Call Me Back'
  },
  LEAD_TRIGGERED_WHATSAPP_DETAIL: {
    EVENT: LEAD_EVENT,
    EVENT_OPTIMIZELY_PROFESSIONAL: 'Lead Detalle Profesionales Whatsapp',
    LEAD_TYPE: 'Detail Ad Replied Whatsapp'
  },
  LEAD_TRIGGERED_RECOMMENDED_PHONE_CALLED_DETAIL: {
    EVENT: LEAD_EVENT,
    EVENT_OPTIMIZELY_PROFESSIONAL: 'Lead Recommended Detalle Profesionales',
    LEAD_TYPE: 'Recommended Phone Called'
  },
  LEAD_TRIGGERED_DETAIL_PROFESSIONAL: {
    EVENT: LEAD_EVENT,
    EVENT_OPTIMIZELY: 'Leads en detalle de profesionales (web)',
    LEAD_TYPE: 'Financed Purchase Email',
    LEAD_TYPE_1: 'Financed Purchase Phone Called',
    PAGE_NAME_ORIGIN: 'detail'
  },
  LEAD_DETAIL_ADS_WITH_INSTALMENT: {
    EVENT: LEAD_EVENT,
    EVENT_OPTIMIZELY: 'Total Lead Detail Ads with instalment (web)',
    LEAD_TYPES: [
      'Detail Ad Replied Email',
      'Detail Phone Called',
      'Financed Purchase Phone Called',
      'Financed Purchase Email'
    ],
    PAGE_NAME_ORIGIN: 'detail'
  },
  LEAD_TRIGGERED_FAVORITES: {
    EVENT: LEAD_EVENT,
    EVENT_OPTIMIZELY: 'Leads de favoritos',
    PAGE_NAME_ORIGIN: 'listado de favoritos'
  },
  PHONE_VIEWED_DETAIL: {
    EVENT: PHONE_VIEWED,
    EVENT_OPTIMIZELY: 'Phone Viewed detail',
    PAGE_NAME_ORIGIN: 'detail'
  },
  RESERVATION_START_CLICKED_DETAIL: {
    EVENT: RESERVATION_START_CLICKED,
    EVENT_OPTIMIZELY: 'Reservation Start Clicked Detail',
    HIT_ORIGIN: 'detail'
  },
  RESERVATION_MORE_INFORMATION_CLICKED_DETAIL: {
    EVENT: RESERVATION_MORE_INFORMATION_CLICKED,
    EVENT_OPTIMIZELY: 'Reservation More Information Detail',
    HIT_ORIGIN: 'detail'
  }
}
